import { HoursOff, UsersPermissionsUser } from "../gql/generated-types";

export interface Role {
  id: string;
  name: string;
  description: string;
  type: RoleType;
}

export enum RoleType {
  manager = "manager",
  employee = "employee",
  account = "account",
  admin = "admin"
}

export type User = Partial<UsersPermissionsUser>;
export type UserForCalendar = {
  hoursOff?: HoursOff[];
  user: User;
};

export enum MessageType {
  SUCCESS,
  ERROR,
  WARNING
}

export type AuthStorage = {
  user?: User;
  role?: string | null;
  /** Strapi 5 documentId of the logged user */
  meId?: string;
  isLoggedIn: boolean;
  token?: string | null;
};

export interface DayWithHolidaysForCal {
  id: string;
  allDay?: boolean;
  backgroundColor?: string;
  borderColor?: string;
  display?: "background";
  start: string;
  title?: string;
  extendedProps?: {
    users: UserForCalendar[];
  };
}

export interface DayWithHolidaysForCalMobile {
  date: string;
  isHoliday?: boolean;
  title?: string;
  users?: UserForCalendar[];
}

export type HolidaysRecordType =
  | DayWithHolidaysForCal
  | DayWithHolidaysForCalMobile;
export type HolidaysRecord<HolidaysRecordType> = Record<
  string,
  HolidaysRecordType
>;
